import { render, staticRenderFns } from "./BranchAccount.vue?vue&type=template&id=617eb6d6&scoped=true"
import script from "./BranchAccount.vue?vue&type=script&lang=js"
export * from "./BranchAccount.vue?vue&type=script&lang=js"
import style0 from "./BranchAccount.vue?vue&type=style&index=0&id=617eb6d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617eb6d6",
  null
  
)

export default component.exports